import { gql } from '@apollo/client'

const checkUserAccess = gql(`
query checkUserAccess( $user: String! $project: String $isFirstSignIn: Boolean $userAgent: String) {
        checkUserAccess(
            user: $user
            project: $project
            isFirstSignIn: $isFirstSignIn
            userAgent: $userAgent
        ) {
            mfaStatus
            projectAccess
        }
    }`
)
export default checkUserAccess

// const two = gql(`
// query two( $user: String! $project: String $isFirstSignIn: Boolean $userAgent: String) {
//         checkUserAccess(
//             user: $user
//             project: $project
//             isFirstSignIn: $isFirstSignIn
//             userAgent: $userAgent
//         ) {
//             mfaStatus
//             projectAccess
//         }
//     }`
// )
// export {
//   two
// }
